import React, {Component} from 'react';
import { Badge,Icon,Menu,Dropdown } from 'jcloudui';
import {Link} from 'react-router';
import logo from './style/logo.png';
import "./style/templateHader.css";
import ApiClient from '../../../apiClient/ApiClient';
export default class Header extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      mainDomain: '/',
    };
  }
  componentWillMount() {
    this.getMainDomainForLogo();
  }

  // 获取域名
  getMainDomainForLogo() {
    var client = new ApiClient();
    client.get('/passport/logout')
      .then(
        (res) => {
          if(res.code == 0 && res.data) {
            res.data.map(_item => {
              if (_item.domainType == 1) {
                let mainDomain = `//${_item.domain}`;
                this.setState({mainDomain: mainDomain});
              }
            });
          }
        },
        (err) => {
        }
      );
    // client.get('/platform-service/mallInfo/getMallInfo')
    //   .then(
    //     (res) => {
    //       if(res.code == 0 && res.data) {
    //         this.priceUrl = res.data.userLogo;
    //       }
    //     },
    //     (err) => {
    //     }
    //   );
  }

  //
  render() {
    const {menus,selectKey} = this.props;
    const horizontal = menus.map((menu)=>{
      return <Menu.Item key={menu.id}><a href={menu.href} target={menu.target}>{menu.name}</a></Menu.Item>;
    });
    return (
      <div className="buyer-framework-header">
        <div className="buyer-framework-container">
          <ul>
            <li><a className="buyer-framework-logo" href={this.state.mainDomain} target="_blank" >{this.props.logo?<img src={this.props.logo} />:''}</a></li>
            <li><span className="buyer-framework-title" >{this.props.type && this.props.type=='subaccount'?'子账号管理':'采购人中心'}</span></li>
          </ul>
          {
            this.props.type && this.props.type=='subaccount'?
              ''
              :
              <Menu
                theme="light"
                mode="horizontal"
                selectedKeys={[String(selectKey)]}
                style={{ lineHeight: '62px', float: 'right'}}
              >
                {horizontal}
              </Menu>
          }
        </div>
      </div>
    )
  }
}